import axios from 'axios';
import { BASE_API_URL } from 'utils/const';

const API_URL = BASE_API_URL + 'orgs/';

export const checkHealth = async (orgId = 2) => {
  try {
    const response = await axios.get(`${API_URL}${orgId}/sync-status`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token').replace(/['"]+/g, '')}`
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error checking org health:', error);
    throw error;
  }
};

const authHeaders = () => ({
  Authorization: `Bearer ${localStorage.getItem('token').replace(/['"]+/g, '')}`
});

export const listOrgs = async () => {
  const response = await axios.get(API_URL, { headers: authHeaders() });
  return response.data;
};

export const createOrg = async (payload) => {
  const response = await axios.post(API_URL, payload, { headers: authHeaders() });
  return response.data;
};

export const updateOrg = async (orgId, payload) => {
  const response = await axios.put(`${API_URL}${orgId}`, payload, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token').replace(/['"]+/g, '')}`
    }
  });
  return response.data;
};

export const getOrgDetails = async (orgId) => {
  try {
    const response = await axios.get(`${API_URL}${orgId}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token').replace(/['"]+/g, '')}`
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching org details:', error);
    throw error;
  }
};

export const enableEmailIngest = async (orgId) => {
  const response = await axios.post(
    `${API_URL}${orgId}/email-ingest`,
    {},
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token').replace(/['"]+/g, '')}`
      }
    }
  );
  return response.data;
};

export const getEmailIngestReportPreview = async (orgId, reportType) => {
  const response = await axios.get(`${API_URL}${orgId}/email-ingest/reports/${reportType}`, {
    headers: authHeaders()
  });
  return response.data;
};

export const saveEmailIngestMapping = async (orgId, reportType, mapping) => {
  const response = await axios.put(
    `${API_URL}${orgId}/email-ingest/reports/${reportType}/mapping`,
    { mapping },
    { headers: authHeaders() }
  );
  return response.data;
};

export const reconcileArAging = async (orgId, file) => {
  const formData = new FormData();
  formData.append('file', file);

  const response = await axios.post(
    `${API_URL}${orgId}/ar-aging-reconcile`,
    formData,
    {
      headers: authHeaders(),
      timeout: 10 * 60 * 1000
    }
  );
  const data = response.data;
  if (data && typeof data === 'object' && data.statusCode >= 400) {
    const message = Array.isArray(data.message) ? data.message.join(' ') : data.message;
    const error = new Error(message || 'Failed to verify AR aging report.');
    error.response = { data };
    throw error;
  }
  return data;
};
